module.exports = __webpack_public_path__ + "static/media/18.cbee17f5.wav";